import { userUtil } from '@liepin/js-core4c-fe';
import cookie from '@liepin/js-core-h5/src/cookie';

export default () => {
  const userRoles = cookie.get('user_roles');
  const loginIsC = userUtil.isLogin && userRoles && userRoles.includes('0');
  return loginIsC;
}
